<template lang="pug">
.q-pa-md.q-gutter-y-sm
  navbar(back="administration-taxonomy-list")
  .row
    div.offset-md-2.col-md-8.offset-sm-1.col-sm-10.q-gutter-md(v-if="taxonomy")
      h6 Správa kontrolovaných slovníků - {{ $langTitle(taxonomy) }}
      q-separator.q-my-md(inset)
      taxonomy-editor(
        :taxonomy-url="taxonomy.links.tree"
        :taxonomy-code="taxonomy.code"
        :editDialogComponent="editDialogComponent"
        :filterMatcher="filterTaxonomy"
      )
        template(v-slot:title="{subtree}")
          span.taxonomy-title {{ $langTitle(subtree) }}

        template(v-slot:item-period="{item}")
          div
            span.term-title(:class="{'term-title-children': item.descendants_count}") {{ $langTitle(item) }}
            div.term-period-years(v-if="item.startYear")
              span {{item.startYear}} - {{ item.endYear }}

        template(v-slot:item-examination-methods="{item}")
          div
            span.term-title(:class="{'term-title-children': item.descendants_count}") {{ $langTitle(item) }}
            div.term-examination-methods-url(v-if="item.url")
              span {{item.url}}
            div.term-tooltip(v-if="item.tooltip")
              span {{item.tooltip}}

        template(v-slot:item="{item}")
          div
            span.term-title(:class="{'term-title-children': item.descendants_count}") {{ $langTitle(item) }}

        template(v-slot:buttons-middle)
          q-btn(flat color="primary" icon="dialpad" size="sm" @click="taxonomyTestShown=true")

      q-dialog(v-model='taxonomyTestShown', v-if='taxonomy')
        q-card(style='width: 700px; max-width: 80vw;')
          q-card-section
            div
              | Zkouška výběru jednoho termínu taxonomie
              br
              dialog-taxonomy-input(label='', v-model='selectedTaxonomyTerm', :taxonomy-code='taxonomy.code',
                :taxonomy-url='taxonomy.links.tree')
                template(v-slot:title="{subtree}")
                  span.taxonomy-title {{ $langTitle(subtree) }}

                template(v-slot:item="{item}")
                  div
                    span.term-title(:class="{'term-title-children': item.descendants_count}") {{ $langTitle(item) }}
                    div.term-period-years(v-if="item.startYear")
                      span {{item.startYear}} - {{ item.endYear }}

          q-card-section
            div
              | Zkouška výběru více termínů taxonomie
              br
              dialog-taxonomy-input(label='', v-model='selectedTaxonomyTermList', :taxonomy-code='taxonomy.code',
                :taxonomy-url='taxonomy.links.tree', :multiple='true' :inline="true")
                template(v-slot:title="{subtree}")
                  span.taxonomy-title {{ $langTitle(subtree) }}

                template(v-slot:item="{item}")
                  div
                    span.term-title(:class="{'term-title-children': item.descendants_count}") {{ $langTitle(item) }}
                    div.term-period-years(v-if="item.startYear")
                      span {{item.startYear}} - {{ item.endYear }}
</template>
<style lang="stylus">
h6
  margin-top 32px
  margin-bottom 16px

.term-title
  font-weight bold

.term-title-children
  color $primary

.term-period-years
  color gray
  padding-left 20px
  font-size smaller
  line-height 70%

.taxonomy-title
  color $secondary

.term-examination-methods-url
  color: darkblue
</style>

<script>
import { Component, Vue } from 'vue-property-decorator'
import PeriodEditDialogComponent from 'components/taxonomies/PeriodEditDialogComponent.vue'
import RequestorEditDialogComponent from 'components/taxonomies/RequestorEditDialogComponent.vue'
import InstitutionEditDialogComponent from 'components/taxonomies/InstitutionEditDialogComponent.vue'
import TaxonomyTermEditDialogComponent from 'components/taxonomies/TaxonomyTermEditDialogComponent.vue'
import Navbar from 'components/Navbar'
import ExaminationMethodsEditDialogComponent from '../../components/taxonomies/ExaminationMethodsEditDialogComponent'

export default @Component({
  props: {
    code: String
  },
  components: {
    'navbar': Navbar
  },
  meta: {
    title: '- Správa kontrolovaných slovníků'
  }
})
class EditTaxonomyPage extends Vue {
  editors = {
    period: PeriodEditDialogComponent,
    requestors: RequestorEditDialogComponent,
    institutions: InstitutionEditDialogComponent,
    'examination-methods': ExaminationMethodsEditDialogComponent
  }
  taxonomyTestShown = false
  selectedTaxonomyTerm = null
  selectedTaxonomyTermList = []

  get taxonomy () {
    if (this.$taxonomies.taxonomies) {
      return this.$taxonomies.taxonomies[this.code]
    } else {
      return null
    }
  }

  get editDialogComponent () {
    return this.editors[this.code] || TaxonomyTermEditDialogComponent
  }

  filterTaxonomy ({ query, term }) {
    return new RegExp(query, 'i').test(this.$langTitle(term))
  }
}
</script>
